//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
SPLM.Annotations.NarrowDimensionData = class{
    constructor(display_type,text_orientation,leader_angle,text_offset){
        this.display_type=display_type;this.text_orientation=text_orientation;this.leader_angle=leader_angle;this.text_offset=text_offset;}
    get DisplayType(){return this.display_type}
    set DisplayType(val){this.display_type = val}
    get TextOrientation(){return this.text_orientation}
    set TextOrientation(val){this.text_orientation = val}
    get LeaderAngle(){return this.leader_angle}
    set LeaderAngle(val){this.leader_angle = val}
    get TextOffset(){return this.text_offset}
    set TextOffset(val){this.text_offset = val}
};

SPLM.Annotations.DiameterSymbol = Object.freeze({
    "Dia" : "Dia", "Standard" : "Standard", "UserDefined" : "UserDefined", "Spherical" : "Spherical", "Last" : "Last"});

SPLM.Annotations.RadiusSymbol = Object.freeze({
    "R" : "R", "RAD" : "RAD", "UserDefined" : "UserDefined", "SR" : "SR", "CR" : "CR", "Last" : "Last"});

SPLM.Annotations.DiameterRadiusSymbolPlacement = Object.freeze({
    "Below" : "Below", "Above" : "Above", "After" : "After", "Before" : "Before", "Omit" : "Omit", "Last" : "Last"});

SPLM.Annotations.DiameterRadiusLeaderStub = Object.freeze({
    "Before" : "Before", "Below" : "Below", "Last" : "Last"});

SPLM.Annotations.DimensionUnit = Object.freeze({
    "Millimeters" : "Millimeters", "Meters" : "Meters", "Inches" : "Inches", "ArchitecturalFeetInches" : "ArchitecturalFeetInches", "EngineeringFeetInches" : "EngineeringFeetInches", "Micrometers" : "Micrometers", "Last" : "Last"});

SPLM.Annotations.AngularDimensionFormat = Object.freeze({
    "FractionalDegrees" : "FractionalDegrees", "WholeDegrees" : "WholeDegrees", "DegreesMinutes" : "DegreesMinutes", "DegreesMinutesSeconds" : "DegreesMinutesSeconds", "Last" : "Last"});

SPLM.Annotations.DimensionTextFormat = Object.freeze({
    "Decimal" : "Decimal", "HalfSizeFraction" : "HalfSizeFraction", "TwoThirdSizeFraction" : "TwoThirdSizeFraction", "FullSizeFraction" : "FullSizeFraction", "Last" : "Last"});

SPLM.Annotations.DecimalPointCharacter = Object.freeze({
    "Period" : "Period", "Comma" : "Comma", "Last" : "Last"});

SPLM.Annotations.TolerancePlacement = Object.freeze({
    "Below" : "Below", "After" : "After", "Above" : "Above", "Last" : "Last"});

SPLM.Annotations.DualDimensionPlacement = Object.freeze({
    "Below" : "Below", "After" : "After", "Above" : "Above", "Before" : "Before", "None" : "None", "Last" : "Last"});

SPLM.Annotations.AngularSuppressZeros = Object.freeze({
    "None" : "None", "Leading" : "Leading", "Any" : "Any", "Trailing" : "Trailing", "Last" : "Last"});

SPLM.Annotations.FractionDenominatorFormat = Object.freeze({
    "One" : "One", "Two" : "Two", "Four" : "Four", "Eight" : "Eight", "Sixteen" : "Sixteen", "ThirtyTwo" : "ThirtyTwo", "SixtyFour" : "SixtyFour", "Last" : "Last"});

SPLM.Annotations.ToleranceType = Object.freeze({
    "None" : "None", "LimitOneLine" : "LimitOneLine", "LimitTwoLines" : "LimitTwoLines", "BilateralOneLine" : "BilateralOneLine", "BilateralTwoLines" : "BilateralTwoLines", "UnilateralAbove" : "UnilateralAbove", "UnilateralBelow" : "UnilateralBelow", "Basic" : "Basic", "Reference" : "Reference", "LimitLargerFirst" : "LimitLargerFirst", "LimitLargerBelow" : "LimitLargerBelow", "LimitsAndFits" : "LimitsAndFits", "NotToScale" : "NotToScale", "DiameterReference" : "DiameterReference", "BasicNotToScale" : "BasicNotToScale", "SingleLimitMax" : "SingleLimitMax", "SingleLimitMin" : "SingleLimitMin"});

SPLM.Annotations.TextPlacement = Object.freeze({
    "Automatic" : "Automatic", "ManualArrowsIn" : "ManualArrowsIn", "ManualArrowsOut" : "ManualArrowsOut", "ManualArrowsInSameDirection" : "ManualArrowsInSameDirection", "Last" : "Last"});

SPLM.Annotations.ExtensionLineDisplay = Object.freeze({
    "Two" : "Two", "First" : "First", "Second" : "Second", "None" : "None", "Last" : "Last"});

SPLM.Annotations.ArrowDisplay = Object.freeze({
    "Two" : "Two", "First" : "First", "Second" : "Second", "None" : "None", "Last" : "Last"});

SPLM.Annotations.TextOrientation = Object.freeze({
    "Horizontal" : "Horizontal", "Aligned" : "Aligned", "OverDimensionLine" : "OverDimensionLine", "ByAngle" : "ByAngle", "Perpendicular" : "Perpendicular", "SplitByDimensionLine" : "SplitByDimensionLine", "Last" : "Last"});

SPLM.Annotations.TextPosition = Object.freeze({
    "AfterStub" : "AfterStub", "AboveStub" : "AboveStub", "Last" : "Last"});

SPLM.Annotations.NarrowDisplayOption = Object.freeze({
    "None" : "None", "NoLeader" : "NoLeader", "WithLeaderNoStub" : "WithLeaderNoStub", "AboveStub" : "AboveStub", "AfterStub" : "AfterStub", "Last" : "Last"});

SPLM.Annotations.NarrowTextOrientation = Object.freeze({
    "Horizontal" : "Horizontal", "Parallel" : "Parallel", "Last" : "Last"});

SPLM.Annotations.ChamferForm = Object.freeze({
    "Symbol" : "Symbol", "Size" : "Size", "SizeAngle" : "SizeAngle", "AngleSize" : "AngleSize", "Last" : "Last"});

SPLM.Annotations.ChamferStubType = Object.freeze({
    "NoneTextAboveLeader" : "NoneTextAboveLeader", "NoneTextAfterLeader" : "NoneTextAfterLeader", "TextAbove" : "TextAbove", "TextAfter" : "TextAfter", "Last" : "Last"});

SPLM.Annotations.ChamferLeaderPlacement = Object.freeze({
    "Perpendicular" : "Perpendicular", "Parallel" : "Parallel", "Linear" : "Linear", "Last" : "Last"});

SPLM.Annotations.ChamferSymbolPlacement = Object.freeze({
    "None" : "None", "Prefix" : "Prefix", "Suffix" : "Suffix", "Last" : "Last"});

SPLM.Annotations.ChamferSeparatorType = Object.freeze({
    "UppercaseX" : "UppercaseX", "LowercaseX" : "LowercaseX"});

SPLM.Annotations.OrdinatePositiveDirection = Object.freeze({
    "All" : "All", "UpperRight" : "UpperRight", "UpperLeft" : "UpperLeft", "LowerRight" : "LowerRight", "LowerLeft" : "LowerLeft", "Last" : "Last"});

SPLM.Annotations.OrdinateOriginDisplayOption = Object.freeze({
    "UserDefinedSymbol" : "UserDefinedSymbol", "OrdinateSetName" : "OrdinateSetName", "NoText" : "NoText", "Last" : "Last"});

SPLM.Annotations.OrdinateLineArrowDisplayOption = Object.freeze({
    "None" : "None", "All" : "All", "Last" : "Last"});

SPLM.Annotations.OrdinateDoglegDefinition = Object.freeze({
    "StartAndEnd" : "StartAndEnd", "StartAngle" : "StartAngle", "EndAngle" : "EndAngle", "Last" : "Last"});

SPLM.Annotations.OrdinateDoglegCreationOption = Object.freeze({
    "Infer" : "Infer", "Yes" : "Yes", "No" : "No", "Last" : "Last"});

SPLM.Annotations.DimensionType = Object.freeze({
    "AngularMajor" : "AngularMajor", "AngularMinor" : "AngularMinor", "ArcLength" : "ArcLength", "Baseline" : "Baseline", "Chain" : "Chain", "Chamfer" : "Chamfer", "ConcentricCircle" : "ConcentricCircle", "Cylindrical" : "Cylindrical", "Diameter" : "Diameter", "FoldedRadius" : "FoldedRadius", "Hole" : "Hole", "Horizontal" : "Horizontal", "OrdinateHorizontal" : "OrdinateHorizontal", "OrdinateOrigin" : "OrdinateOrigin", "OrdinateVertical" : "OrdinateVertical", "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "Radius" : "Radius", "Vertical" : "Vertical", "Last" : "Last"});

SPLM.Annotations.RadiusDimensionType = Object.freeze({
    "ToCenter" : "ToCenter", "NotToCenter" : "NotToCenter", "Last" : "Last"});

SPLM.Annotations.TrimDimensionLineStyle = Object.freeze({
    "DoNotTrim" : "DoNotTrim", "Trim" : "Trim"});

SPLM.Annotations.ZeroToleranceDisplayStyle = Object.freeze({
    "BasedOnUnits" : "BasedOnUnits", "AsZero" : "AsZero", "OmittedAndInlined" : "OmittedAndInlined", "Omitted" : "Omitted"});

SPLM.Annotations.ChamferOrientationType = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical", "Parallel" : "Parallel"});

SPLM.Annotations.FitDisplayStyle = Object.freeze({
    "FitSymbols" : "FitSymbols", "FitSymbolsAndLimits" : "FitSymbolsAndLimits", "FitSymbolsAndTolerances" : "FitSymbolsAndTolerances", "TolerancesOnly" : "TolerancesOnly"});

SPLM.Annotations.FitAssemblyDisplayStyle = Object.freeze({
    "SingleLine" : "SingleLine", "TwoLinesCentered" : "TwoLinesCentered", "TwoLinesAligned" : "TwoLinesAligned"});

SPLM.Annotations.FitAssemblyNewDisplayStyle = Object.freeze({
    "SingleLine" : "SingleLine", "DoubleLine" : "DoubleLine"});

SPLM.Annotations.FitDisplaySplitByDimline = Object.freeze({
    "None" : "None", "ToleranceOnly" : "ToleranceOnly", "ToleranceAndValue" : "ToleranceAndValue"});

SPLM.Annotations.FitDisplayAlignment = Object.freeze({
    "CenterValue" : "CenterValue", "CenterValueAndFit" : "CenterValueAndFit", "Bottom" : "Bottom"});

SPLM.Annotations.FitAnsiHoleType = Object.freeze({
    "Hole" : "Hole", "Shaft" : "Shaft", "Fit" : "Fit"});

SPLM.Annotations.TrueLengthTextPosition = Object.freeze({
    "None" : "None", "Prefix" : "Prefix", "Suffix" : "Suffix"});

SPLM.Annotations.InspectionSymbolAroundAppendedText = Object.freeze({
    "None" : "None", "Before" : "Before", "After" : "After", "BeforeAfter" : "BeforeAfter", "All" : "All"});

SPLM.Annotations.ReferenceIncludeType = Object.freeze({
    "ValuePrefixTolerance" : "ValuePrefixTolerance", "OnlyValue" : "OnlyValue"});

export default SPLM;